import React, { FC } from 'react';

import { ChildrenProps, cn, resultIf } from '../../../utils';

import './Main.scoped.scss';

interface Props extends ChildrenProps {
  cabinet?: boolean;
}

const Main: FC<Props> = ({ children, cabinet = false }) => {
  return <main className={cn('main', resultIf(cabinet, 'main--cabinet'))}>{children}</main>;
};

export default Main;
